/**
 * ShpfltMulticolumn - Multicolumn grid section with configurable column layout.
 *
 * @example
 * <shpflt-multicolumn data-section-id="{{ section.id }}">
 *   ...
 * </shpflt-multicolumn>
 */
import { ShopigurusHTMLElement } from '@shopigurus/base';

class ShpfltMulticolumn extends ShopigurusHTMLElement {
  /**
   * Fires when the DOM element is inserted.
   */
  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * Fires when the DOM element is removed.
   */
  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Fires when section is selected in Shopify editor.
   */
  onSectionSelect() {
    // Section is selected in editor - add visual feedback if needed
  }

  /**
   * Fires when section is deselected in Shopify editor.
   */
  onSectionDeselect() {
    // Section is deselected in editor
  }
}

customElements.define('shpflt-multicolumn', ShpfltMulticolumn);
